import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { OpenDialogFunction } from '@/domain/state/dialogs/slice'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'
import { borrowDialogConfig } from '@/features/sparklend/dialogs/borrow/BorrowDialog'
import { repayDialogConfig } from '@/features/sparklend/dialogs/repay/RepayDialog'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { Button, ButtonIcon, ButtonProps } from '@/ui/atoms/button/Button'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'

export interface BorrowActionButtonProps {
  reserve: Reserve
  initialBorrowToken: SparkLendToken
  openDialog: OpenDialogFunction
  showTokenIcon?: boolean
}

export function BorrowActionButton({
  reserve,
  initialBorrowToken,
  openDialog,
  showTokenIcon,
}: BorrowActionButtonProps) {
  return (
    <ActionButton
      variant="secondary"
      disabled={reserve.status === 'frozen'}
      action={() => {
        openDialog(borrowDialogConfig, { reserve, initialBorrowToken })
      }}
      actionLabel="Borrow"
      token={initialBorrowToken}
      showTokenIcon={showTokenIcon}
    />
  )
}

export interface RepayActionButtonProps {
  reserve: Reserve
  initialRepayToken: SparkLendToken
  openDialog: OpenDialogFunction
  debt: NormalizedNumber
  showTokenIcon?: boolean
}

export function RepayActionButton({
  reserve,
  initialRepayToken,
  openDialog,
  debt,
  showTokenIcon,
}: RepayActionButtonProps) {
  return (
    <ActionButton
      variant="tertiary"
      disabled={debt.isZero()}
      action={() => {
        openDialog(repayDialogConfig, { reserve, initialRepayToken })
      }}
      actionLabel="Repay"
      token={initialRepayToken}
      showTokenIcon={showTokenIcon}
    />
  )
}

interface ActionButtonProps {
  variant: ButtonProps['variant']
  disabled: boolean
  actionLabel: string
  action: () => void
  token: SparkLendToken
  showTokenIcon?: boolean
}

function ActionButton({ variant, disabled, action, actionLabel, token, showTokenIcon }: ActionButtonProps) {
  return (
    <Button variant={variant} className="w-full gap-1" size="s" onClick={action} disabled={disabled}>
      {showTokenIcon && <ButtonIcon icon={() => <TokenIcon token={token} className="size-4 shrink-0" />} />}{' '}
      {actionLabel}
    </Button>
  )
}
